import {
	ArrayComparisonConfig,
	CustomLogConfig,
	IfGateConfig,
	LoopConfig,
	MicroTaskConfig,
	MicrotaskType,
	ParallelSplitConfig,
	TaskMapping,
} from 'ihub/common';

export function getSubTaskMappings(
	microTask: MicroTaskConfig,
	mappings: TaskMapping[]
): TaskMapping[] {
	const mappingsToReturn: TaskMapping[] = [];

	switch (microTask.taskType) {
		case MicrotaskType.IfGate: {
			const subIfGateConfig = microTask.config as IfGateConfig;
			for (const ifRuleGroup of subIfGateConfig.rules) {
				const successMapping = mappings.find(m => m.id === ifRuleGroup.successMappingID);
				if (successMapping) mappingsToReturn.push(successMapping);

				const failureMapping = mappings.find(m => m.id === ifRuleGroup.failureMappingID);
				if (failureMapping) mappingsToReturn.push(failureMapping);
			}
			break;
		}
		case MicrotaskType.Loop: {
			const subLoopTaskConfig = microTask.config as LoopConfig;
			const loopMapping = mappings.find(m => m.id === subLoopTaskConfig.loopDestinationID);
			if (loopMapping) mappingsToReturn.push(loopMapping);
			break;
		}
		case MicrotaskType.ParallelSplit: {
			const subParallelSplitConfig = microTask.config as ParallelSplitConfig;
			for (const split of subParallelSplitConfig.parallelSplitMappings) {
				const successMapping = mappings.find(m => m.id === split.successMappingID);
				if (successMapping) mappingsToReturn.push(successMapping);

				const failureMapping = mappings.find(m => m.id === split.failureMappingID);
				if (failureMapping) mappingsToReturn.push(failureMapping);
			}
			break;
		}
		case MicrotaskType.ArrayComparison: {
			const subArrayComparisonTask = microTask.config as ArrayComparisonConfig;
			const remainingMapping = mappings.find(
				m => m.id === subArrayComparisonTask.remainingDestinationID
			);
			if (remainingMapping) mappingsToReturn.push(remainingMapping);
			break;
		}
		case MicrotaskType.CustomLog: {
			const subCustomLogTask = microTask.config as CustomLogConfig;
			for (const logItem of subCustomLogTask.messageHandlers) {
				const successMapping = mappings.find(m => m.id === logItem.successMappingID);
				if (successMapping) mappingsToReturn.push(successMapping);

				const failureMapping = mappings.find(m => m.id === logItem.failureMappingID);
				if (failureMapping) mappingsToReturn.push(failureMapping);
			}
			break;
		}
	}

	return mappingsToReturn;
}
